export const proratedGB = (cap: number, when: Date = new Date()): number => {
  const year = when.getFullYear();
  const month = when.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const remaining = daysInMonth - when.getDate() + 1;
  return +(cap * remaining / daysInMonth).toFixed(1);
}; 